export const postToParentCallback =
  (type: string) =>
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  (payload?: any): void => {
    const searchParams = new URLSearchParams(window.location.search);
    const targetOrigin = searchParams.get('origin');
    const isSalesforce = searchParams.get('salesforce')?.toLowerCase() === 'true';

    if (!targetOrigin && !isSalesforce) {
      console.error(
        'No origin provided, unable to post message to iframe parent. Please refer to the iframe integration doc here: https://docs.arcadia.com/docs/integrate-connect#iframe-events to begin receiving callbacks. '
      );
      return;
    }

    // We need to serialize as a plain object because Error objects
    // are not supported in postMessages in Safari.
    const sanitizedPayload = payload ? JSON.parse(JSON.stringify(payload)) : payload;
    const message = { type, payload: sanitizedPayload };

    if (targetOrigin && !isSalesforce) {
      window.parent.postMessage(message, targetOrigin);
    }

    // Only proceed with Salesforce integration if salesforce=true
    if (isSalesforce && typeof Sfdc !== 'undefined' && Sfdc?.canvas?.client) {
      Sfdc.canvas.client.refreshSignedRequest(function (data: {
        status: number;
        payload: { response: string };
      }) {
        if (data.status === 200) {
          const signedRequestResponse = data.payload.response;
          const signedReqObj = JSON.parse(Sfdc.canvas.decode(signedRequestResponse.split('.')[1]));

          const { client } = signedReqObj;
          Sfdc.canvas.client.publish(client, {
            name: 'urjanet.connectEvent',
            payload: message,
          });
        }
      });
    }
  };
